import SubscribePage from "@/features/landing/views/subscribe-view";
import { createFileRoute } from "@tanstack/react-router";

// Inferred path: /subscribe
export const Route = createFileRoute("/subscribe")({
  component: SubscribePage,
});
